import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme'
import { LenguageService } from '../../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  operation: string;

  constructor(
    protected dialogRef: NbDialogRef<ConfirmDialogComponent>,
    public language: LenguageService
  ) { }

  ngOnInit() {
    if (!this.operation) {
      this.operation = this.language.getLabel("confirm_placeholder");
    }
  }

  result(result: boolean) {
    this.dialogRef.close(result)
  }

}
